import { render, staticRenderFns } from "./LoadDetails.vue?vue&type=template&id=ae8b173a&scoped=true&"
import script from "./LoadDetails.vue?vue&type=script&lang=js&"
export * from "./LoadDetails.vue?vue&type=script&lang=js&"
import style0 from "./LoadDetails.vue?vue&type=style&index=0&id=ae8b173a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae8b173a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
